import apiClient from '../../../utils/clients/axios'

export const
    MilkClient = async (payload) => {
        const response = await apiClient.post(
            '/milk',
            payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )

        return response
    }